import React, { FC, useState } from "react";

import { Appointment } from "../AppointmentPreviewCard/types";
import Button from "../../Unknown/Button";
import useStyles from "../AppointmentModifyServicesDialogContainer/useStyles";

import useTranslations from "./translations";
import AppointmentEditAddOnsDialog from "./dialog";

export type AppointmentEditAddOnsDialogContainerProps = {
  appointment: Appointment;
  handleSuccess: () => void | Promise<void>;
};

const AppointmentEditAddOnsDialogContainer: FC<
  AppointmentEditAddOnsDialogContainerProps
> = ({ appointment, handleSuccess }) => {
  const [isOpened, setIsOpened] = useState(false);
  const { translations } = useTranslations();
  const classes = useStyles();

  return (
    <>
      <Button
        variant="contained"
        size="small"
        onClick={() => setIsOpened(true)}
        className={classes.btnEdit}
      >
        {translations.editButton}
      </Button>
      {isOpened && (
        <AppointmentEditAddOnsDialog
          isOpened={isOpened}
          appointment={appointment}
          onClose={() => setIsOpened(false)}
          handleSuccess={handleSuccess}
        />
      )}
    </>
  );
};

export default AppointmentEditAddOnsDialogContainer;
